export default {
  title: 'Feature Flags',
  subtitle: 'Ativar ou desativar funcionalidades da plataforma para {{company}}.',
  no_company: 'Selecione um restaurante para gerir as suas feature flags.',
  columns: {
    feature: 'Funcionalidade',
    status: 'Estado',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (direto)',
      description:
        'Permite que este restaurante receba pagamentos PayPal diretamente na sua própria conta PayPal. Ativado por predefinição para restaurantes de parceiros faturados pela Foodamigos, onde a taxa de serviço ao cliente também é cobrada nestes pagamentos e a parte da plataforma é faturada ao parceiro.',
    },
    vip_free_flyers: {
      name: 'Flyers mensais gratuitos',
      description:
        'Enviar automaticamente 500 flyers promocionais por mês a este restaurante (predefinição: ativo para o tier VIP e Star).',
    },
    custom_store_seo: {
      name: 'SEO personalizado da loja',
      description: 'Permitir que este restaurante gira as definições de SEO personalizadas da sua loja online.',
    },
    external_printer: {
      name: 'Impressora de recibos externa',
      description:
        'Permitir que este restaurante ligue uma impressora de rede à app do terminal de encomendas, em vez de imprimir na impressora integrada do terminal.',
    },
    stripe_payment_element: {
      name: 'Checkout com Stripe Payment Element',
      description:
        'Permite que a própria conta Stripe do restaurante decida quais métodos de pagamento são oferecidos no checkout. Ative apenas quando a plataforma Stripe tiver os métodos de pagamento configurados para contas associadas.',
    },
  },
  toasts: {
    enabled: 'Funcionalidade ativada.',
    disabled: 'Funcionalidade desativada.',
    error: 'Não foi possível atualizar a funcionalidade. Tente novamente.',
    load_error: 'Não foi possível carregar as feature flags.',
  },
};
